import fetch from 'node-fetch';
import history from '../../../../history';
import { showToaster } from '../../../../helpers/toastrMessgaes/showToaster';

const mutation = `
mutation addContentPageDetails(
  $id:Int,
  $metaTitle: String,
  $metaDescription: String,
  $pageUrl: String,
  $pageTitle: String,
  $content: String,
  $pageBanner: String
  $dynamicContentData: [dynamicContentInput]
) {
  addContentPageDetails(
    id:$id,
    metaTitle: $metaTitle,
    metaDescription: $metaDescription,
    pageUrl: $pageUrl,
    pageTitle: $pageTitle,
    content: $content,
    pageBanner: $pageBanner
    dynamicContentData: $dynamicContentData
  ) {
      status
      errorMessage
  }
}
`;

async function submit(values, dispatch) {

  try {
    if (values.content == null || values.content == '<p><br></p>' || values.content == '<p> </p>') {
      showToaster({ messageId: 'addCmsContent', toasterType: 'error' });
      return
    }
    let content = values?.content[0]?.content;

    const response = await fetch('/graphql', {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        query: mutation,
        variables: {
          content,
          metaTitle: values?.metaTitle,
          metaDescription: values?.metaDescription,
          pageTitle: values?.pageTitle,
          id: values?.id,
          pageUrl: values?.pageUrl,
          dynamicContentData: values?.content,
          pageBanner: values?.pageBanner
        }
      }),
      credentials: 'include'
    });

    const { data } = await response.json();

    if (data?.addContentPageDetails?.status === 200) {
      showToaster({ messageId: 'changesUpdated', toasterType: 'success' });
      history.push('/siteadmin/contentpage/manage')
    }
    else if (data?.addContentPageDetails?.status !== 200)
      showToaster({ messageId: 'errorMessage', requestContent: { content: data?.addContentPageDetails?.errorMessage }, toasterType: 'error' });
    else showToaster({ messageId: 'errorMessage', toasterType: 'error' });
  }
  catch (error) {
    showToaster({ messageId: 'catchMessage', requestContent: { content: error }, toasterType: 'error' });
  }
}

export default submit;